import { Button, Flex, InputNumber, Modal, Spin } from 'antd';

import type { ModelProductItem } from '@app/api/Products';
import { useDeleteProductsModal } from '@app/components/Modals/DeleteProductsModal/hooks';
import { InfoRow } from '@app/components/Modals/DeleteProductsModal/ui';
import {
  formatCount,
  formatPriceRange,
} from '@app/components/Modals/DeleteProductsModal/utils';

import type { FC } from 'react';

import '@app/components/Modals/DeleteProductsModal/styles/DeleteProductsModal.desktop.scss';

export interface DeleteProductsModalProps extends ModelProductItem {
  open: boolean;
  onClose(): void;
  afterDelete?(): void;
}

export const DeleteProductsModal: FC<DeleteProductsModalProps> = (props) => {
  const { open, Warehouse, Name, Count, PriceOfSaleS, PriceOfSaleE, onClose } =
    props;
  const {
    countToDelete,
    setCountToDelete,
    isDeleting,
    deleteHandler,
    isLoading,
  } = useDeleteProductsModal(props);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Удаление товара со склада"
      footer={
        <Flex
          className="DeleteProductsModal__footer"
          justify="space-between"
          align="center"
        >
          <Button onClick={onClose} disabled={isDeleting}>
            Отменить
          </Button>

          <Button
            type="primary"
            danger
            onClick={deleteHandler}
            loading={isDeleting}
            disabled={
              !countToDelete ||
              countToDelete <= 0 ||
              countToDelete > (Count ?? 0)
            }
          >
            Удалить
          </Button>
        </Flex>
      }
      destroyOnHidden
      className="DeleteProductsModal"
    >
      <div className="DeleteProductsModal__content">
        <Spin spinning={isDeleting || isLoading}>
          <div className="DeleteProductsModal__rows">
            <InfoRow label="Товар:" value={Name} />
            <InfoRow label="Склад:" value={Warehouse} />
            <InfoRow
              label="Цена:"
              value={formatPriceRange(PriceOfSaleS, PriceOfSaleE)}
            />
            <InfoRow label="Количество:" value={formatCount(Count)} />

            <Flex
              className="DeleteProductsModal__row"
              align="center"
              justify="space-between"
              gap={16}
            >
              <div className="DeleteProductsModal__rowLabel">
                Количество к удалению:
              </div>

              <div className="DeleteProductsModal__rowValue">
                <InputNumber
                  className="DeleteProductsModal__countInput"
                  min={1}
                  max={Count ?? undefined}
                  value={countToDelete ?? undefined}
                  onChange={setCountToDelete}
                  controls
                />
              </div>
            </Flex>

            <InfoRow
              label="Остаток после удаления:"
              value={formatCount(
                Count !== null && countToDelete !== null
                  ? Count - countToDelete
                  : null
              )}
            />
          </div>
        </Spin>
      </div>
    </Modal>
  );
};
